import { render, staticRenderFns } from "./RemoveLinkedModel.vue?vue&type=template&id=2a8997e1&scoped=true&"
import script from "./RemoveLinkedModel.vue?vue&type=script&lang=ts&"
export * from "./RemoveLinkedModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8997e1",
  null
  
)

export default component.exports